import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import competition from './competition@2x.svg';
import dealership from './dealership@2x.svg';
import market from './market@2x.svg';
import none from './none@2x.svg';
import { get } from 'lodash';
import styles from './styles.module.scss';

const iconMapping = () => ({
  COMPETITION: competition,
  DEALER: dealership,
  CLUSTER: market,
  NONE: none,
});

export const icon = ({ charm, iconMapping }) => {
  const charmType = get(iconMapping, charm.id);
  const showCharm = charm.recommended;
  return showCharm ? charmType : none;
};

export const iconAlt = ({ charm }) => {
  const showCharm = charm.recommended;
  return showCharm ? charm.id.toLowerCase : 'none';
};

export const charmStyle = ({ detail }) => {
  return detail ? styles.charmDetail : styles.charm;
};

export default compose(
  addProps({
    iconMapping,
  }),
  addProps({
    icon,
    iconAlt,
    charmStyle,
  }),
);
